export default {"src":"/_next/static/media/instagram-icon.9a35453b.svg","height":96,"width":96};